import { render, staticRenderFns } from "./DashboardCustomer.vue?vue&type=template&id=347a6746&scoped=true"
import script from "./DashboardCustomer.vue?vue&type=script&lang=js"
export * from "./DashboardCustomer.vue?vue&type=script&lang=js"
import style0 from "./DashboardCustomer.vue?vue&type=style&index=0&id=347a6746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a6746",
  null
  
)

export default component.exports